import { createStyles, makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex'
    },
    grid: {
      minHeight: 400,
      width: '100%',
      backgroundColor: '#ebebeb',
      padding: 3,
      borderRadius: 10,
      alignContent: 'center'
    },
    details: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%'
    },
    content: {
      flex: 'auto'
    },
    alert: {
      width: '100%',
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper
    },
    ticketHeader: {
      fontSize: '1.5em',
      marginLeft: '15px'
    },
    ticketOrder: {
      fontSize: '2.5em',
      marginLeft: '15px'
    },
    button: {
      marginLeft: 10,
      marginTop: 10
    },
    warning: {
      backgroundColor: '#ffea00',
      color: 'white',
      '&:hover': {
        backgroundColor: '#b2a300',
        color: 'white'
      }
    },
    difference: {
      backgroundColor: '#f48fb1',
      color: 'white',
      '&:hover': {
        backgroundColor: '#d81b60',
        color: 'white'
      }
    },
    filterButton: {
      borderRadius: '30px',
      height: '28px',
      color: 'black',
      fontSize: '0.7em'
    },
    manage: {
      '&:hover': {
        backgroundColor: '#027db2',
        color: 'white'
      }
    },
    sucess: {
      backgroundColor: '#4caf50',
      color: 'white',
      '&:hover': {
        backgroundColor: '#357a38',
        color: 'white'
      }
    }
  })
)
